function reloadWindow() {
    window.location.reload();
}

export { reloadWindow };
